import React from 'react';
import {
  PageWithHeader,
  Content,
  ContentHeader,
  CreateButton,
} from '@backstage/core-components';
import { useApi, configApiRef } from '@backstage/core-plugin-api';
import { CatalogTable } from '@backstage/plugin-catalog';
import {
  EntityListProvider,
  CatalogFilterLayout,
  EntityKindPicker,
  EntityLifecyclePicker,
  EntityNamespacePicker,
  EntityOwnerPicker,
  EntityProcessingStatusPicker,
  EntityTagPicker,
  EntityTypePicker,
  UserListPicker,
} from '@backstage/plugin-catalog-react';
import { PermissionWrapper } from '../Root/PermissionWrapper';
import { dxPortalAdvancedFeaturesPermission } from '@internal/shared/src/permission/opa_permissions';

export const CustomCatalogIndex = () => {
  const orgName =
    useApi(configApiRef).getOptionalString('organization.name') ?? 'Backstage';

  return (
    <PageWithHeader
      title={`${orgName} Catalog`}
      subtitle="Catalogue aggregates all items created in DX Portal as a single
          searchable page. Any template, service or document created will be
          displayed in groups with filtering and search capability."
      themeId="home"
    >
      <Content>
        <ContentHeader>
          <PermissionWrapper permission={dxPortalAdvancedFeaturesPermission}>
            <CreateButton title="Create" to="/create" />
          </PermissionWrapper>
        </ContentHeader>
        <EntityListProvider>
          <CatalogFilterLayout>
            <CatalogFilterLayout.Filters>
              <EntityKindPicker />
              <EntityTypePicker />
              <UserListPicker />
              <EntityOwnerPicker />
              <EntityLifecyclePicker />
              <EntityTagPicker />
              <EntityProcessingStatusPicker />
              <EntityNamespacePicker />
            </CatalogFilterLayout.Filters>
            <CatalogFilterLayout.Content>
              <CatalogTable />
            </CatalogFilterLayout.Content>
          </CatalogFilterLayout>
        </EntityListProvider>
      </Content>
    </PageWithHeader>
  );
};
